import { InjectionToken } from '@angular/core';
import { ListViewDataResult } from '@progress/kendo-angular-listview';
import { Observable } from 'rxjs';
import { GridState } from './grid-state.model';

/**
 * Provider of the values offered by the checkbox list of app-custom-filter.
 * The values are read from the server so the list holds every value the other
 * filters left in, not only the ones that fit on the current page.
 */
export interface DistinctItemsSource {
  getDistinctItems(
    state: GridState,
    view: string,
    field: string,
    restaurantId?: string,
    extraParams?: Record<string, string | string[]>,
  ): Observable<ListViewDataResult>;
}

/**
 * Bound by each feature module to the service that knows the endpoint of its
 * own grids, so app-custom-filter can live in shared without depending on any
 * of them.
 */
export const DISTINCT_ITEMS_SOURCE = new InjectionToken<DistinctItemsSource>(
  'DISTINCT_ITEMS_SOURCE',
);
